export default {
  products: 'Prodotti',
  search: 'Cerca',
  accountArea: 'Area riservata',
  whyUs: 'Perché noi',
  services: 'Servizi',
  company: 'Azienda',
  news: 'News',
  resources: 'Risorse',
  contacts: 'Contatti',
  shop: 'Shop',
  privacy: 'Privacy Policy',
  cookie: 'Cookie Policy',
  copyright: 'Copyright',
  conditions: 'Condizioni di utilizzo',
  language: 'Cambia lingua',
  comeFarePer: 'Come fare per',
}
